/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Обший вид валидируемой формы
   * Определяет обработку сохранения формы с валидацией
   */
  app.ValidatedFormView = app.FormView.extend({
    validate: function (e) {
      if (this.onValidate || this.onSave) {
        return;
      }
      this.onValidate = true;
      e.preventDefault();
      e.stopPropagation();
      var field = this.$(e.currentTarget),
        data = this.getData();
      this.model.save(data, {
        success: (function () {
          this.onValidate = false;
          this.onSave = false;
          this.clearErrors();
        }).bind(this),
        error: (function (model, response) {
          this.onValidate = false;
          var errors = this._parseErrors(response.responseText);
          if (_.isArray(errors)) {
            this.fillErrors(errors, field);
          }
          if (this.$('.field.error').length) {
            var firstErrorField = $(this.$('.field.error')[0]);
            $('html, body').animate({
              scrollTop: firstErrorField.offset().top + firstErrorField.height() + 100 - $(window).height() / 2
            }, 500);
          }
        }).bind(this)
      });
    },
    save: function (notScroll) {
      if (this.onValidate || this.onSave) {
        return;
      }
      this.onSave = true;
      var data = this.getData();
      this.noScroll = notScroll;
      return this.model.save(data, {
        success: this.success.bind(this),
        error: this.error.bind(this)
      });
    },
    /**
     * Парсит ошибки из ответа сервера, кидает исключение при ошибках парсинга.
     * @param text Текст ответа сервера
     * @returns {array} Ошибки валидации
     * @private
     */
    _parseErrors: function (text) {
      var errors;
      try {
        errors = JSON.parse(text);
        this.trigger('error', JSON.parse(text));
      } catch (e) {
        var error = new SyntaxError('Parsing data with form errors caused the error. JSON: ' + text);
        if (e.stack) {
          error.stack = e.stack;
        }
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException(error);
        } else {
          throw error;
        }
      }
      return errors;
    },
    /**
     * Заполнение ошибок
     * @param {array} errors массив ошибок формы
     * @param {array} field валидируемое поле
     */
    fillErrors: function (errors, field) {
      var hasNotFieldErrors = [],
        hasError = false;
      errors.forEach((function (error) {
        if (!field || (field && field.length && field.attr('name') === error.field)) {
          this._getError(error.field).text(error.message);
          this._getField(error.field).addClass('error');
          if (!field && !this._getError(error.field).length) {
            hasNotFieldErrors.push(error);
          }
          this._getExample(error.field).addClass('not_display');
          hasError = true;
        }
      }).bind(this));
      
      if (field && field.length && !hasError) {
        this._getError(field.attr('name')).text('');
        this._getField(field.attr('name')).removeClass('error');
        this._getExample(field.attr('name')).removeClass('not_display');
      }
      
      if (hasNotFieldErrors.length) {
        app.helpers.ErrorHelper.globalValidationError(hasNotFieldErrors, this.globalErrorMsg);
      }
    },
    _getField: function (field) {
      return this.$('#' + this.formName + '-' + field);
    },
    _getError: function (field) {
      return this.$('#' + this.formName + '-' + field + '-error');
    },
    _getExample: function (field) {
      return this.$('.js-' + this.formName + '-' + field + '-example');
    }
  });
})();

}.call(window));